import { SortRounded } from "../../images/SortRoundedImg";
import { AccountListItem } from "../../../types";
import React from "react";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";

export interface ColumnList {
  id: string;
  key: Exclude<keyof AccountListItem, "discovery" | "engagement">;
  label: string;
  minWidth: string;
  maxWidth: string;
  sortable?: boolean;
  icon?: React.ElementType;
  iconAsc?: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  iconDesc?: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  type:
    | "checkbox"
    | "text"
    | "menu"
    | "penetration_score"
    | "total_engagement_score";
  flexAlign: "flex-start" | "center" | "flex-end";
  textAlign: "left" | "center" | "right";
  tooltip?: string;
}
export const columnsList: ColumnList[] = [
  {
    id: "data_source",
    key: "index",
    label: "",
    minWidth: "48px",
    maxWidth: "48px",
    sortable: true,
    iconAsc: SortRounded,
    type: "text",
    flexAlign: "flex-start",
    textAlign: "left",
  },
  {
    id: "first_name",
    key: "company",
    label: "Company",
    minWidth: "15%",
    maxWidth: "28%",
    sortable: true,
    iconAsc: SortRounded,
    type: "text",
    flexAlign: "flex-start",
    textAlign: "left",
  },
  {
    id: "last_name",
    key: "industry",
    label: "Industry",
    sortable: true,
    iconAsc: SortRounded,
    minWidth: "130px",
    maxWidth: "28%",
    type: "text",
    flexAlign: "flex-start",
    textAlign: "left",
  },
  {
    id: "seniority",
    key: "size",
    label: "Size",
    minWidth: "70px",
    maxWidth: "100px",
    sortable: true,
    iconAsc: SortRounded,
    type: "text",
    flexAlign: "flex-end",
    textAlign: "right",
  },
  {
    id: "job_title",
    key: "region",
    label: "Region",
    minWidth: "80px",
    maxWidth: "104px",
    sortable: true,
    iconAsc: SortRounded,
    type: "text",
    flexAlign: "flex-end",
    textAlign: "left",
  },
  {
    id: "total_engagement_score",
    key: "total_engagement_score",
    label: "Engagement",
    minWidth: "120px",
    maxWidth: "140px",
    sortable: true,
    iconAsc: SortRounded,
    type: "total_engagement_score",
    flexAlign: "center",
    textAlign: "right",
    tooltip:
      "Engagement rate of all identified potential BC members, based on outgoing" +
      " and replied calls & emails, and communication recency over all time.",
  },
  {
    id: "penetration_score",
    key: "penetration_score",
    label: "Discovery",
    minWidth: "110px",
    maxWidth: "124px",
    sortable: true,
    iconAsc: SortRounded,
    type: "penetration_score",
    flexAlign: "center",
    textAlign: "right",
    tooltip:
      "Rate of potential BC members, identified in the available data, considering" +
      " the expected BC size.",
  },
  {
    id: "menu",
    key: "id",
    label: "",
    minWidth: "46px",
    maxWidth: "46px",
    type: "menu",
    flexAlign: "center",
    textAlign: "center",
  },
  {
    id: "checkbox",
    key: "id",
    label: "",
    minWidth: "42px",
    maxWidth: "46px",
    type: "checkbox",
    flexAlign: "center",
    textAlign: "center",
  },
];
